import { AxiosAdapter } from '../../_config/adapters/axios/axios.adapter';
import { Http } from '../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { Country } from './country';

export class Service {
	async searchProducts(query, pharmacy = null) {

		let filters =  Country[Enviroment.COUNTRY].handleFilters(query);
		let elasticEngine = Country[Enviroment.COUNTRY].handleIndex()
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.ELASTIC_ENVIROMENT}/api/as/v1/engines/${elasticEngine}/search`,
			headers: {
				Authorization: `Bearer ${Enviroment.ELASTIC_KEY}`,
			},
			data: {
				query: Country[Enviroment.COUNTRY].handleQuery(query),
				filters: filters,
				page: {
					size: 20,
					current: 1,
				},
			},
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
